import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "full-width flex items-center" }
const _hoisted_2 = { class: "q-pr-sm" }

import { LoanProposalStatus_Enum } from "src/types/enums/index";
  import { LoanApplication, VehicleRuleResult } from "src/types/loan-application/index";

  import { PropType, watch, computed} from "vue";

  import { useProposalStore } from "src/stores/proposal-store";
  
 

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LenderDecisions',
  props: {
    app: {
      type: Object as PropType<LoanApplication>,
      default: null
    },
    quickQuote: {
      type: Boolean,
      default: false
    },
  },
  setup(__props) {


  const proposalStore = useProposalStore();

  const props = __props

  watch(props.app, () => {
    if (props.app.proposals && props.app.proposals.length > 0) {
      const a = states.value;
    }
  })

  const states = computed(() => {
    if (!props.app || !props.app.vehicle || !props.app.vehicle.lenderDecisions) {
      return [];
    }

    const v = props.app.vehicle.lenderDecisions.findIndex(d => d.name === "Failed Lender Vehicle Rules");
    if(v > -1){
      props.app.vehicle.lenderDecisions[v].rows.sort((a, b) => a.title.localeCompare(b.title));
    }
    const c = props.app.vehicle.lenderDecisions.findIndex(d => d.name === "Failed Lender Customer Rules");
    if(c > -1){
      props.app.vehicle.lenderDecisions[c].rows.sort((a, b) => a.title.localeCompare(b.title));
    }
    return props.app.vehicle.lenderDecisions;
  })

  function sanitiseRule(message: string) {

    if (message.toLocaleLowerCase().includes("rn") ||
    message.toLocaleLowerCase().includes("bankruptcy") || 
    message.toLocaleLowerCase().includes("arrears") || 
    message.toLocaleLowerCase().includes("credit") ||
    message.toLocaleLowerCase().includes("default") ||
    message.toLocaleLowerCase().includes("insolvency") ||
    message.toLocaleLowerCase().includes("ccj") ||
    message.toLocaleLowerCase().includes("iva") ||
    message.toLocaleLowerCase().includes("account")){
      return "Customer has failed the lender's credit or application rules."
    }

    return message;
  }

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(states.value, (state, si) => {
    return (_openBlock(), _createElementBlock("div", {
      key: state.name+'-ldt',
      class: "q-mt-md no-highlight"
    }, [
      (state.name === 'Approved' && state.rows.length > 0)
        ? (_openBlock(), _createBlock(_component_q_card, {
            key: 0,
            class: "q-mb-md",
            bordered: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode(" These approvals are on the customer only but the vehicle has passed all of the known lender rules. Our underwriting team will now proceed in getting a full approval on the vehicle. ")
                ])),
                _: 1,
                __: [0]
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (state.rows.length > 0)
        ? (_openBlock(), _createBlock(_component_q_card, {
            key: 1,
            bordered: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_expansion_item, {
                label: state.name,
                "header-class": si === 0 ? 'rounded-borders bg-dark text-white text-subtitle1' : 'bg-dark text-white text-subtitle1',
                "expand-icon-class": "text-white",
                "default-opened": state.defaultOpened
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(state.name), 1),
                    _createVNode(_component_q_badge, {
                      color: "white",
                      rounded: "",
                      class: "text-dark text-subtitle3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(state.rows.length), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_q_list, { separator: "" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.rows, (row, index) => {
                        return (_openBlock(), _createBlock(_component_q_item, {
                          key: state.name+'-'+row.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_section, { side: "" }, {
                              default: _withCtx(() => [
                                (state.loading === true)
                                  ? (_openBlock(), _createBlock(_component_q_spinner, {
                                      key: 0,
                                      color: "primary"
                                    }))
                                  : (_openBlock(), _createBlock(_component_q_avatar, {
                                      key: 1,
                                      color: row.iconColour,
                                      size: "20px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_icon, {
                                          name: row.icon,
                                          color: "white",
                                          style: {"font-size":"16px","font-weight":"bold"}
                                        }, null, 8, ["name"])
                                      ]),
                                      _: 2
                                    }, 1032, ["color"]))
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_q_item_section, {
                              style: _normalizeStyle({'max-width':  state.name === 'Approved' ? '220px' : 'unset'})
                            }, {
                              default: _withCtx(() => [
                                (!row.title.includes('Predicted'))
                                  ? (_openBlock(), _createBlock(_component_q_item_label, {
                                      key: 0,
                                      class: "text-subtitle2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(row.title), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : (_openBlock(), _createBlock(_component_q_item_label, {
                                      key: 1,
                                      class: "text-subtitle2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(row.title.replace(' (Predicted)', '')), 1)
                                      ]),
                                      _: 2
                                    }, 1024)),
                                (row.subtext)
                                  ? (_openBlock(), _createBlock(_component_q_item_label, {
                                      key: 2,
                                      innerHTML: sanitiseRule(row.subtext),
                                      class: "text-body2"
                                    }, null, 8, ["innerHTML"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["style"]),
                            (row.title.includes('Predicted'))
                              ? (_openBlock(), _createBlock(_component_q_item_section, { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, [
                                      _createVNode(_component_q_badge, {
                                        color: "dark",
                                        class: "text-overline text-white text-uppercase q-ml-sm"
                                      }, {
                                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                                          _createTextVNode("Predicted")
                                        ])),
                                        _: 1,
                                        __: [1]
                                      })
                                    ])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["label", "header-class", "default-opened"])
            ]),
            _: 2
          }, 1024))
        : _createCommentVNode("", true)
    ]))
  }), 128))
}
}

})